import { getSchema } from '../../decorators/utilities/get.merge.schema';
import { MergeField } from '../../decorators/decorators/merge.field';
import { MergeSchema } from '../../decorators/decorators/merge.schema';
import { ActivityEntityName } from '../../../../entities/shared/activity.entity.name';
import { EmbeddedCode } from '../../../../entities/shared/code';
import { EmployeeMergeData } from './employee.merge.data';

@MergeSchema({
    entity: ActivityEntityName.WorkOrder,
    name: 'StageMergeSchema',
})
export class StageMergeData {

    @MergeField()
    _id: string;

    @MergeField({ hidden: true })
    jobId: string;

    @MergeField({ displayName: 'Stage Number' })
    workOrderNumber: string;

    @MergeField()
    sortOrder: string = '';

    @MergeField()
    version: number;

    @MergeField()
    name: string;

    @MergeField()
    description: string;

    @MergeField()
    status: string;

    @MergeField()
    createdAt: string;

    @MergeField()
    startDate: string;

    @MergeField()
    dueDate: string;

    @MergeField()
    completedDate: string;

    @MergeField()
    finalisedDate: string;

    @MergeField()
    completedSignature: string;

    @MergeField()
    completedSignatureName: string;

    @MergeField()
    completedNote: string;

    @MergeField()
    finalisedNote: string;

    @MergeField()
    pricebook: string;

    @MergeField()
    totalBuyPrice: string;

    @MergeField()
    totalSellPrice: string;

    @MergeField()
    workCategory: string;

    @MergeField()
    tags: string;

    @MergeField()
    systemTags: string;

    @MergeField({
        arraySchemaName: "EmployeeMergeSchema",
    })
    resources: EmployeeMergeData[];

    @MergeField()
    timezone: string;

    // Superseded by nextAppointmentStartDate; still filled so templates written against it keep printing.
    @MergeField({
        displayName: 'Next Appointment Date (deprecated)'
    })
    nextAppointmentDate: string = ''

    // Superseded by nextAppointmentStartDateTime; still filled so templates written against it keep printing.
    @MergeField({
        displayName: 'Next Appointment Date Time (deprecated)'
    })
    nextAppointmentDateTime: string = ''

    @MergeField()
    nextAppointmentStartDate: string = ''

    @MergeField()
    nextAppointmentStartTime: string = ''

    @MergeField()
    nextAppointmentStartDateTime: string = ''

    @MergeField()
    nextAppointmentEndDate: string = ''

    @MergeField()
    nextAppointmentEndTime: string = ''

    @MergeField()
    nextAppointmentEndDateTime: string = ''

    @MergeField()
    nextAppointmentResourceName: string = ''

    @MergeField()
    contractorName: string;

    @MergeField()
    contractorPhone: string;

    @MergeField()
    contractorEmail: string;

    customFields: any;
    codes?: EmbeddedCode[];
}

export const StageMergeSchema = getSchema(StageMergeData);
